import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';

import { getAgentByID, getAgentcontactList, getagentlist } from '../../Services/Service';
import { deletePropertyAgent } from '../../Redux/Slices/Property/slice';

const Agentlist = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const deleting = useSelector((state) => state.propertyAgent.deleting);
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [agentList, setAgentList] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [selectedLoginID, setSelectedLoginID] = useState(null);



    useEffect(() => {
        if (location.state?.success) {
            setSuccessMessage(location.state.success);
            setShowSuccess(true);


            setTimeout(() => setShowSuccess(false), 4000);
        }
    }, [location.state]);


    const getAgentsList = useCallback(async () => {
        setLoading(true);
        try {
            const result = await getagentlist();
            if (Array.isArray(result)) {
                setAgentList(result);
            }
        }
        catch (error) {
            console.log("error getting agent list", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getAgentsList();
    }, [getAgentsList]);



    const handleEditClick = async (agentID) => {
        const data = await getAgentByID(agentID);
        navigate('/Property/NewAgent', { state: { agentData: data } });
    };

    const handleDeleteClick = async (agentID) => {
    const shouldDelete = await swal({
        title: "Are you sure?",
        icon: "warning",
        buttons: ["Cancel", "Delete"],
        dangerMode: true,
    });

    if (!shouldDelete) return;

    try {
        const { response } = await dispatch(
            deletePropertyAgent(agentID)
        ).unwrap();

        // Ye call karo, kyunki ye agentList state update karta hai
        await getAgentsList();

        await swal(response?.Message || "Agent deleted successfully", {
            icon: "success",
        });

    } catch (error) {
        await swal(error?.Message || "Something went wrong", {
            icon: "error",
        });
    }
};



    // useEffect(() => {
    //     const $ = window.$;
    //     if (agentList.length > 0 && $ && $.fn.dataTable) {
    //         const table = $('.basic-datatables').DataTable();
    //         if (table) {
    //             table.destroy();
    //         }
    //         setTimeout(() => {
    //             $('.basic-datatables').DataTable();
    //         }, 0);
    //     }
    // }, [agentList]);

    // Contact List API Call
    const handleOpenContactList = async (loginID) => {
        setSelectedLoginID(loginID);
        setLoading(true);
        try {
            const contactResult = await getAgentcontactList(loginID);
            console.log("Contact List Response:", contactResult);
            setContactList(contactResult?.Table || []);
        } catch (error) {
            console.error("Error fetching contact list:", error);
            setContactList([]);
        } finally {
            setLoading(false);
        }
    };



    // const handleNewContactClick = () => {
    //     const modal = document.getElementById('example-modal-lg');
    //     const instance = window.bootstrap.Modal.getInstance(modal);
    //     instance?.hide();

    //     navigate('/Property/RateUpdateForm');
    // };


    const handleNewContactClick = () => {
        const modal = document.getElementById('example-modal-lg');
        const instance = window.bootstrap.Modal.getInstance(modal);
        instance?.hide();

        if (selectedLoginID) {
            const propertyID = localStorage.getItem("PropertyID");
            navigate(`/Property/RateUpdateForm?R=TA-${selectedLoginID}&PropertyID=${propertyID}`);
        } else {
            alert("No Agent Selected");
        }
    };


    return (
        <>

            {(loading || deleting) && (
                <FullScreenLoader />
            )}
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />

                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    {showSuccess && (
                                        <div className="alert alert-success d-flex align-items-center" role="alert">
                                            <i className="feather-check-circle flex-shrink-0 me-2"></i>
                                            <div>{successMessage}</div>
                                        </div>
                                    )}

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Agent List</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table id="agentTable"
                                                    // id="basic-datatables"
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>


                                                            <th>TA</th>
                                                            <th>City</th>
                                                            <th>Contact Person Name</th>
                                                            <th>Phone</th>
                                                            <th>Opera Link </th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {agentList.map((agent, index) => (
                                                            <tr key={agent.AgentID || index}>


                                                                <td>{agent.TA_Name || 'N/A'}</td>
                                                                <td>{agent.City || 'N/A'}</td>
                                                                <td>{`${agent.FirstName || ''} ${agent.MidlleName || ''} ${agent.LastName || ''}`.trim() || 'N/A'}</td>

                                                                <td>{agent.MobileNo || 'N/A'}</td>

                                                                <td>{agent.OperaProfileID ? "Yes" : "No"}</td>

                                                                <td className="text-center">
                                                                    <div className="dropdown dropdown-action position-absolute" style={{ marginInline: "13px", marginTop: "-9px" }}>
                                                                        <a href="/" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <button className="dropdown-item" onClick={() => handleEditClick(agent.AgentID)}> <i className="fas fa-edit me-2"></i>Edit </button>
                                                                            <button type="button" className=" dropdown-item" data-bs-toggle="modal" data-bs-target="#example-modal-lg" onClick={() => handleOpenContactList(agent.LoginID)}><i className="fas fa-user me-2"></i> Contact List</button>
                                                                            <button className="dropdown-item" type="button" onClick={() => handleDeleteClick(agent.AgentID)} disabled={deleting}> <i className="fas fa-trash me-2"></i>Delete </button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <>
                        {/*  Modal */}
                        <div
                            className="modal fade"
                            id="example-modal-lg"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="myLargeModalLabel"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="myLargeModalLabel">
                                            contact list
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="table-responsive">

                                            <div className='text-end mb-3'>
                                                <button className='btn btn-sm btn-black' onClick={handleNewContactClick}> New Contact  </button>
                                            </div>
                                            <table className="table table-bordered table-nowrap mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Contact On</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {contactList.length > 0 ? (
                                                        contactList.map((contact, index) => (
                                                            <tr key={index}>
                                                                <td>{contact.StartDate || "N/A"}</td>
                                                                <td>{contact.EndDate || "N/A"}</td>
                                                                <td>{contact.CreatedDate || "N/A"}</td>
                                                                <td className='text-center'>
                                                                    <button className="btn btn-sm btn-dark py-1 px-2"><i className='fas fa-edit'></i></button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">No Contact Found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Modal */}
                    </>
                </div>

            </div>
        </>
    );
};

export default Agentlist;
